import { SetStateAction, Dispatch, useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'

import GreenHeart from 'assets/images/emojis/green-heart.png'
import LineChart from 'assets/images/emojis/line-chart.png'
import Card from 'assets/images/card.png'
import HandsUp from 'assets/images/emojis/hands-up.png'
import Piggy from 'assets/images/emojis/piggy-emoji.png'
import Warning from 'assets/images/emojis/warning-emoji.png'

import PrimaryButton from 'components/primaryButton'
import ModalContainer from 'components/ModalContainer'
import RoundedIcon from 'components/RoundedIcon'

interface CreditLinesModalProps {
  isShown: boolean
  setModalFunction: Dispatch<SetStateAction<boolean>>
}

interface Item {
  icon: string
  text: string
  id: number
}

const INFO: Item[] = [
  {
    id: 1,
    icon: Card,
    text: 'Las líneas de crédito representan los montos y límites que tenés disponible para solicitar en nuestros productos.'
  },
  {
    id: 2,
    icon: HandsUp,
    text: 'Contás con límites diferenciados para Adelantos y Préstamos que podrás utilizar siempre que tengas saldo disponible.'
  },
  {
    id: 3,
    icon: Piggy,
    text: 'Los adelantos Tasa 0% consumen tu línea de crédito de Adelantos.'
  },
  {
    id: 4,
    icon: Warning,
    text: 'Recordá que tu saldo se libera una vez cancelada la totalidad del saldo pendiente.'
  },
  {
    id: 5,
    icon: LineChart,
    text: 'Aumentá tus límites pagando tus cuotas en tiempo y accedé a nuevos montos cuando finalices el crédito.'
  },
  {
    id: 6,
    icon: GreenHeart,
    text: 'Con Wayni+ tus límites se actualizan más rápido y con mejores tasas.'
  }
]

const CreditLinesModal = ({
  isShown,
  setModalFunction
}: CreditLinesModalProps) => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_que_son_lineas_de_credito' })
  }, [])

  return (
    <ModalContainer
      isShown={isShown}
      setModalFunction={setModalFunction}
      className='text-black'
      noCloseButton
    >
      <h3 className='font-bold text-center'>
        ¿Qué son las líneas de <br /> crédito?
      </h3>
      <div className='space-y-4 my-4'>
        {INFO.map((i) => (
          <ListItem key={i.id} text={i.text} img={i.icon} />
        ))}
      </div>
      <PrimaryButton
        primaryButtonFunction={() => setModalFunction(false)}
        buttonText='¡Entendido!'
      />
    </ModalContainer>
  )
}

export default CreditLinesModal

const ListItem = ({ text, img }: { text: string; img?: string }) => (
  <div className='flex gap-2 items-center'>
    <RoundedIcon
      className='h-6 w-6'
      icon={<img className='shrink-0 w-3 h-auto' src={img} alt='' />}
    />
    <p className='font-medium text-2xs leading-[14px]'>{text}</p>
  </div>
)
